// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import {
  fontSize,
  fontWeight,
  mediaMax,
  mediaMin,
  spacing,
} from 'presentations/views/styles';
import Link from 'presentations/views/components/atoms/Link';
import { gray03, gray01 } from 'presentations/views/styles/color';
import {
  helpCenterPath,
  privacyPolicyPath,
  termsPath,
} from 'presentations/routes/path';
import { formatToYear } from 'infras/datetime';

export default function Component() {
  const t = translateInComponent(translations);
  return (
    <Container>
      <List>
        <ListItem>
          <ListItemLink href={helpCenterPath()} target="_blank">
            {t('Help')}
          </ListItemLink>
        </ListItem>
        <ListItem>
          <ListItemLink href={termsPath()}>{t('Terms')}</ListItemLink>
        </ListItem>
        <ListItem>
          <ListItemLink href={privacyPolicyPath()}>
            {t('Privacy Policy')}
          </ListItemLink>
        </ListItem>
      </List>
      <Copyright>
        © Copyright {formatToYear()} Jicoo, Inc. All rights reserved.
      </Copyright>
    </Container>
  );
}

const Container = styled.div``;
const Copyright = styled.div`
  text-align: center;
  font-size: ${fontSize(12)};
  font-weight: ${fontWeight('bold')};
  color: ${gray01};
  padding: 0 0 ${spacing(16)};
`;
const List = styled.ul`
  font-size: ${fontSize(12)};
  text-align: center;
  padding: ${spacing(16)} 0;
  color: ${gray03};
  display: flex;
  align-items: center;
  ${mediaMin.tablet} {
    /* margin-left: auto; */
    justify-content: center;
  }
  ${mediaMax.tablet} {
    justify-content: center;
  }
`;

const ListItem = styled.li`
  text-align: center;
  margin-right: ${spacing(16)};
  :last-of-type {
    margin-right: 0;
  }
`;
const ListItemLink = styled(Link)`
  color: ${gray01};
  font-size: ${fontSize(11)};
`;
